<template>
  <div class="ERP">
    <div class="page_img">
      <img src="@/assets/img/erp_system.jpg" alt="">
    </div>
    <div class="page_content flex_row content">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="erp_summary page_summary font_shadow">ERP系统</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/erp_main.png" alt="">
      <div class="erp_explain main_explain">VISUMALL平台标准接口全部开放，可以自由接入ERP系统。专业视光技术，专业进销存管理，一体式智能平台，不再使用孤立系统</div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_main1">
        <img src="@/assets/img/erp_main1.png" alt="">
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'ERP',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
    }
  },
  created() {
  },
}
</script>

<style scoped lang="scss">
.ERP {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    margin-bottom: 1rem;
    img {
      width: 50%;
    }
    .erp_explain {
      margin-top: 1rem;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.19rem;
      font-weight: 500;
    }
  }
  .container {
    margin-bottom: 1.3rem;
    flex-wrap: wrap;
    .container_item {
      width: 20%;
      flex-direction: column;
      margin-top: 0.55rem;
      img {
        width: 80%;
      }
      span {
        margin-top: 0.1rem;
        font-size: 0.22rem;
        font-weight: bold;
      }
    }
  }
  .system {
    margin-bottom: 1.9rem;
    .sys_main1 {
      img {
        width: 55%;
      }
    }
  }

}
</style>
